import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { COLORS } from '../../utils/colors';
import { useScheduleCardDetailsStyles } from '../../pages/Home/ScheduleCardDetails/styles';

const DetailsItem = ({
  heading,
  value,
  mt = '.75rem',
  md = 5,
}: {
  heading?: string;
  value?: string | React.ReactNode;
  marginBottom?: string;
  mt?: string;
  md?: number;
}) => {
  const scheduleCardDetailsStyles = useScheduleCardDetailsStyles();

  return (
    <Grid item md={md} xs={12} marginTop={mt}>
      <Typography
        sx={scheduleCardDetailsStyles.detailsHeading}
        color={COLORS.MEDIUM_GRAY}>
        {heading ? heading : ''}
      </Typography>
      {typeof value === 'string' ? (
        <Typography
          width="90%"
          fontSize=".875rem"
          fontWeight={500}
          color={COLORS.TEXT}
          sx={{ wordWrap: 'break-word', whiteSpace: 'pre-line' }}>
          {value.split('\\\\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </Typography>
      ) : (
        <>{value}</>
      )}
    </Grid>
  );
};

export default DetailsItem;
